import React from "react";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import ContractDocumentViewer from "./ContractDocumentViewer";

export default function SepaMandateSignDialog({
  open,
  onClose,
  mandateLabel,
  loading,
  error,
  previewError,
  sepaUrl,
  canvasRef,
  onBeginDraw,
  onDrawMove,
  onEndDraw,
  onClearSignature,
  acceptedTerms,
  onAcceptedTermsChange,
  submitting,
  onSubmit,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Assinar Mandato SEPA</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Mandato: {mandateLabel || "-"}
          </Typography>

          <ContractDocumentViewer
            loading={loading}
            type="sepa"
            sepaUrl={sepaUrl}
            frameHeight={420}
          />

          <Box
            sx={{
              border: "1px solid #c8d1dc",
              borderRadius: 1,
              backgroundColor: "#fff",
              p: 1,
            }}
          >
            <canvas
              ref={canvasRef}
              style={{ width: "100%", height: 220, touchAction: "none", display: "block", cursor: "crosshair" }}
              onPointerDown={onBeginDraw}
              onPointerMove={onDrawMove}
              onPointerUp={onEndDraw}
              onPointerLeave={onEndDraw}
            />
          </Box>

          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="caption" color="text.secondary">
              Assinatura obrigatória do cliente para o mandato SEPA.
            </Typography>
            <Button size="small" onClick={onClearSignature}>Limpar assinatura</Button>
          </Stack>

          <FormControlLabel
            control={(
              <Checkbox
                checked={acceptedTerms}
                onChange={(event) => onAcceptedTermsChange?.(event.target.checked)}
              />
            )}
            label="Confirmo que o cliente leu e aceitou os termos do mandato SEPA."
          />

          {previewError ? <Alert severity="warning">{previewError}</Alert> : null}
          {error ? <Alert severity="error">{error}</Alert> : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={submitting || !acceptedTerms}
        >
          Confirmar assinatura
        </Button>
      </DialogActions>
    </Dialog>
  );
}
